import firebase from 'firebase/compat/app';

export type IssueReportPriority = '' | 'low' | 'medium' | 'high';
export type IssueReportType =
  | 'report'
  | 'report-gadget'
  | 'dashboard'
  | 'dashboard-gadget'
  | 'scorecard'
  | GadgetType;

const ISSUE_REPORT_ENDPOINT =
  'https://fleetops-internal.web.app/api/tasks/external';

const submitIssueReport = async ({
  type,
  title,
  description,
  priority,
  files,
  sourceUrl,
  accountId,
  userEmail,
  gadgetName,
}: {
  type: IssueReportType;
  title: string;
  description: string;
  priority: IssueReportPriority;
  files: File[];
  sourceUrl: string;
  accountId: string;
  userEmail: string;
  gadgetName?: string;
}): Promise<boolean> => {
  const form = new FormData();
  form.append('type', type);
  form.append('title', title);
  form.append('description', description);
  form.append('priority', priority);
  form.append('sourceUrl', sourceUrl);
  form.append('accountId', accountId);
  form.append('userEmail', userEmail);
  form.append('source', 'fleetops-client');
  if (gadgetName !== undefined) {
    form.append('gadgetName', gadgetName);
  }
  for (const file of files) {
    form.append(file.name, file);
  }

  const headers: Record<string, string> = {};
  const user = firebase.auth().currentUser;
  if (user) {
    const token = await user.getIdToken();
    headers.authorization = `Bearer ${token}`;
  }

  const response = await fetch(ISSUE_REPORT_ENDPOINT, {
    method: 'POST',
    body: form,
    headers,
  });
  return response.ok;
};

export default submitIssueReport;
